import pkg from '../package.json';
export const BASE_URI_PATH = `/${pkg.name}`;
export const BASE_URL = `${window.location.protocol}//${window.location.host}`;
export const API_URL = `${BASE_URL}/api`;
// export const CUSTOMIZATION_JSON_URL = `${process.env.PUBLIC_URL}/webauth-customization.json`;
